/**
 * ERC Driver Conflict Validator Adapter for DRC System
 *
 * This validator checks for nets with multiple strong driver pins.
 * Multiple drivers can cause bus contention and component damage.
 *
 * Feature-gated via DrcEnabledCheckers.ErcDriverConflictValidator
 */
import { ReviewType } from "@buildwithflux/models";
import { getProblemTypeKeyFromReviewType } from "../../drc/types";
import { isStrongDriver, getPinTypeName } from "../pinTypes";
import { getPinsForNet, createErcProblem, formatPinReference } from "./ercUtils";
/**
 * Validator that checks for multiple drivers on the same net.
 */
export class ErcDriverConflictValidator {
    reviewType = ReviewType.DesignRuleCheckErcDriverConflict;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    defaultHidden = true;
    async checkForProblems(inputs) {
        const foundProblems = [];
        for (const [netHash, terminals] of Object.entries(inputs.netMap)) {
            const pins = getPinsForNet(inputs, terminals);
            if (pins.length < 2) {
                continue;
            }
            const driverPins = [];
            for (const pin of pins) {
                if (isStrongDriver(pin.pinType)) {
                    driverPins.push(pin);
                }
            }
            if (driverPins.length > 1) {
                const driverNames = driverPins
                    .map((p) => `${formatPinReference(p)} (${getPinTypeName(p.pinType)})`)
                    .join(", ");
                const message = `Net has multiple drivers: ${driverNames}. This can cause bus contention.`;
                foundProblems.push(createErcProblem(this.problemTypeKey, `${this.problemTypeKey}_${netHash}`, message, driverPins.map((p) => p.elementUid), driverPins.map((p) => formatPinReference(p))));
            }
        }
        return {
            error: false,
            problemTypeKey: this.problemTypeKey,
            foundProblems,
        };
    }
}
//# sourceMappingURL=ErcDriverConflictValidator.js.map